var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-info-page" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "rz-block" }, [
      _c("div", { staticClass: "line-block" }, [
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm.isSM != "true"
          ? _c("div", { staticClass: "card-statu" }, [
              _c("div", { staticClass: "statu-text" }, [_vm._v("去认证")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSM == "true"
          ? _c("div", { staticClass: "card-statu" }, [
              _c("div", { staticClass: "statu-text" }, [_vm._v("已认证")]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isSM != "true"
        ? _c("div", { staticClass: "rz-block" }, [
            _c("div", { staticClass: "line-block-phone" }, [
              _c("div", { staticClass: "line-block-phone-title" }, [
                _vm._v("身份信息"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "id-style" }, [
                _vm._v("手机号码：" + _vm._s(_vm.userInfo.phone)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "id-style" }, [
                _vm._v("身份证号码：" + _vm._s(_vm.userInfo.id_number)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "id-style" }, [
                _vm._v("身份编码：" + _vm._s(_vm.openid)),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSM != "true"
        ? _c("div", { staticClass: "rz-block" }, [
            _c("div", { staticClass: "line-block-phone" }, [
              _c("div", { staticClass: "line-block-phone-input" }, [
                _c(
                  "div",
                  { staticClass: "rm-code" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "sm-button",
                        attrs: { type: "success" },
                        on: {
                          click: function ($event) {
                            return _vm.yanzheng_code()
                          },
                        },
                      },
                      [_vm._v("去实名认证")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head-img-block" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("../../images/icon/1.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-icon" }, [
      _c("img", {
        staticClass: "card-icon-img",
        attrs: { src: require("../../images/icon/2.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-text" }, [
      _c("div", { staticClass: "lx-font" }, [_vm._v("实名认证")]),
      _vm._v(" "),
      _c("div", { staticClass: "s-font" }, [_vm._v("上传身份信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }